export const PENDING_CHANGES_HINTS = {
  filtersApply: 'Changes are ready — click Apply to update the list.',
  unsavedEdits: 'You have unsaved changes — save or cancel before closing.',
};

export const DISCARD_UNSAVED_CONFIRM = {
  title: 'Discard unsaved changes?',
  message: 'You have unsaved changes that will be lost if you close now.',
  confirmText: 'Discard',
  cancelText: 'Keep editing',
};

export const DISCARD_UNSAVED_ENTITY_NAV_CONFIRM = {
  title: 'Discard unsaved changes?',
  message:
    'You have unsaved entity changes that will be lost if you leave this page.',
  confirmText: 'Discard',
  cancelText: 'Keep editing',
};
